module.exports = __webpack_public_path__ + "assets/img/d6108498b41310166197beed67ef5885.webp";